export default __webpack_public_path__ + "static/media/cinetpay-logo.76e0742f.png";